import { render, staticRenderFns } from "./UserExpressLocation.vue?vue&type=template&id=233f4b12&"
import script from "./UserExpressLocation.vue?vue&type=script&lang=js&"
export * from "./UserExpressLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports